import Modals from "../../../components/common/Modal";
import RedemptionRequest from "./RedemptionRequest";

function RedemptionRequestModel({ open, setOpen }) {
  // const userRole = "BUYER";
  const userRole = atob(sessionStorage.getItem("argument6"));
  // const userRole = localStorage.getItem('argument6');
  return (
    <>
      <Modals
        title={"Redemption Request for OPESS Balance"}
        show={open === "RedemptionRequestModel"}
        handleClose={() => setOpen("")}
        size="md"
      >
        {userRole === "BUYER" && (
          <RedemptionRequest handleClose={() => setOpen("")} />
        )}{" "}
        {/* Pass handleClose prop */}
      </Modals>
    </>
  );
}

export default RedemptionRequestModel;
